import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { MotorTranspModel } from '../shared/models/motorTranspModel';
import { JsonReturn, ObjectParam, TranspToken } from '../shared/interface/generic-interface';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(
    private conService: ApiConService
  ) { }

  async getTokens(): Promise<TranspToken[]> {
    try {
      const response: JsonReturn = await this.conService.patch('DCtranspToken');
      return response.response;
    } catch (error) {
      console.log("Erro ao consultar tokens:", error);
      return []; 
    }
  }

  async geraToken(token) {
    try {
      const response: JsonReturn = await this.conService.post('DCtranspToken', token);
      return response.response;
    } catch (error) {
      console.log("Erro ao gerar token:", error);
      return []; 
    }
  }

  async atualizaToken(objParam: ObjectParam) {
    try {
      const response = await this.conService.put('DCtranspToken', objParam.transpToken.transpTokenID.toString(), objParam);
      return response[0];
    } catch (error) {
      console.log("Erro ao editar token:", error);
      return []; 
    }
  }

  async getTransportadoras(): Promise<MotorTranspModel[]> {
    try {
      const response: JsonReturn = await this.conService.patch('DCmotorTransp');
      return response.response;
    } catch (error) {
      console.log("Erro ao consultar transportadora", error);
      return []; 
    }
  }

  async getEmpresas() {
    try {
      let empresas: JsonReturn = await this.conService.patch('DCEmpresa');
      let empresa = empresas.response.find((empresa) => empresa.cdEmp == 1)
      
      if(empresa == undefined){
        empresa = empresas.response[0]
      }

      return empresa.cnpj;
    }
    catch (error) {
      console.error(' Não foi possivel requisitar nenhuma empresa ou filial')
      console.log(error);

    }
  }
}
